import { NavLink, Outlet } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import logo from '../assets/alelo-logo.svg'
import { initials } from '../lib/profile'
import { copy } from '../lib/i18n'
import './account.css'

export function AccountShell() {
  const { user, logout } = useAuth0()
  const display =
    user?.name || user?.nickname || user?.email || 'Usuário'
  const short =
    display.length > 14 ? `${display.slice(0, 12)}…` : display

  return (
    <div className="acct">
      <header className="acct-header">
        <img src={logo} alt="Alelo" className="acct-logo" width={88} height={40} />
        <div className="acct-user">
          <span className="acct-user-name">{short}</span>
          <span className="acct-avatar" aria-hidden>
            {initials(display)}
          </span>
          <button
            type="button"
            className="acct-logout"
            onClick={() =>
              logout({ logoutParams: { returnTo: window.location.origin } })
            }
          >
            {copy.nav.logout}
          </button>
        </div>
      </header>

      <div className="acct-body">
        <nav className="acct-nav" aria-label={copy.nav.label}>
          <NavLink to="/account" end>
            {copy.nav.overview}
          </NavLink>
          <NavLink to="/account/personal-info">{copy.nav.personalInfo}</NavLink>
          <NavLink to="/account/security">{copy.nav.security}</NavLink>
        </nav>
        <div className="acct-main">
          <Outlet />
        </div>
      </div>

      <footer className="acct-footer">
        <span>© {new Date().getFullYear()} Alelo. Todos os direitos reservados.</span>
        <span className="acct-lang">Português (Brasil)</span>
      </footer>
    </div>
  )
}
